const photos = [
  {
    alt: "réparation fenêtre aluminium Strasbourg",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/e20b202d3a8cfe802b6b7de6bc4aecbf.jpeg",
    prompt: "A professional technician repairing a modern aluminum window frame with precision tools, close-up on hands and metal hardware fittings, the window mechanism partially open, warm natural lighting, clean French home interior, professional repair service, soft warm tones, photorealistic, no people",
    seq: 801,
    w: 800,
    h: 600,
  },
  {
    alt: "mécanisme fenêtre aluminium Bas-Rhin",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/29c0332e41f27ec1411b421aaf430bf9.jpeg",
    prompt: "Close-up of a modern aluminum window frame mechanism with sleek metal fittings and slim profiles, professional repair context, bright natural lighting, warm neutral tones, detailed hardware photography, photorealistic, no people",
    seq: 802,
    w: 800,
    h: 600,
  },
  {
    alt: "crémone fenêtre aluminium Schiltigheim",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/3634f9d39659db9176e76a16d74f8391.jpeg",
    prompt: "A professional technician replacing a window cremone lock on a modern aluminum window frame, close-up on hands installing the metal locking mechanism, the slim aluminum frame visible, indoor French home setting, bright natural light, clean background, professional service, photorealistic, warm tones",
    seq: 803,
    w: 800,
    h: 600,
  },
  {
    alt: "gond fenêtre aluminium Haguenau",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/bd084ece0f605aaf741e29b1ec5721a0.jpeg",
    prompt: "A professional technician replacing a window hinge on a modern aluminum window frame, close-up on hands and metal bracket attached to the slim profile, warm natural lighting, clean French home interior, professional repair service, soft warm tones, photorealistic",
    seq: 804,
    w: 800,
    h: 600,
  },
  {
    alt: "poignée fenêtre aluminium Illkirch",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/3553f70ef7a1a743d1c0f13382581e92.jpeg",
    prompt: "A professional technician replacing a modern metallic window handle on an aluminum window frame, close-up on hands installing the new handle, the slim aluminum profile visible, bright natural lighting inside a French home, clean interior, professional repair service, photorealistic, warm tones",
    seq: 805,
    w: 800,
    h: 600,
  },
  {
    alt: "réglage fenêtre aluminium Strasbourg centre",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/23eb1b95702aea6f23d59e6631489d05.jpeg",
    prompt: "A professional technician adjusting the compression mechanism on a modern aluminum window with a specialized tool, close-up on the slim frame and hardware, bright natural light, clean modern interior, professional repair service, photorealistic, warm tones",
    seq: 806,
    w: 800,
    h: 600,
  },
];

export default function Gallery() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="max-w-4xl">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-8 md:mb-10">
            Galerie photos — réparation fenêtre Aluminium
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {photos.map((photo, i) => (
            <div
              key={i}
              className="aspect-[4/3] rounded-2xl overflow-hidden border border-rose-200 bg-rose-50"
            >
              <img
                src={
                  photo.src ||
                  `https://readdy.ai/api/search-image?query=${encodeURIComponent(photo.prompt)}&width=${photo.w}&height=${photo.h}&seq=${photo.seq}&orientation=landscape`
                }
                alt={photo.alt}
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}